import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ReadConfigService } from './read-config.service';
import { AppConfigService } from 'src/app/app-config.service';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';

@Injectable()
export class CommonService {

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private readConfigService: ReadConfigService) { }

  readonly rootUrl = this.readConfigService.getApiUrl();
  reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
  reqNoAuthHeader = new HttpHeaders({ 'No-Auth': 'True' });

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  getNews(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_NEWS_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(map((response: any) => response),
        catchError(err => this.handleError(err)));
  }

  getNewsById(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_NEWS_BY_ID_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(map((response: any) => response),
        catchError(err => this.handleError(err)));
  }

  getLocations(): Observable<any> {
    const url = this.rootUrl + Global.BASE_USERLOCATION_ENDPOINT;
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(map((response: any) => response as any),
        catchError(this.handleError));
  }

  getTrackerTasks(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_TRACKER_TASK_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(map((response: any) => response),
        catchError(err => this.handleError(err)));
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error || 'Server error');
  }
}
